import { Maybe } from 'dibs-ts-utils/exports/Maybe';

type DisplayInfo = Maybe<{
    ctas: Maybe<{
        showPurchase: Maybe<boolean>;
        showMakeOffer: Maybe<boolean>;
        showRequestPrice: Maybe<boolean>;
        showFollowCategory: Maybe<boolean>;
        showAcceptOffer: Maybe<boolean>;
    }>;
}>;

type Sku = Maybe<{
    serviceId: Maybe<string>;
    displayInfo: DisplayInfo;
}>;

type GetDisplayInfo = (args: {
    displayInfo: DisplayInfo;
    skus?: Maybe<ReadonlyArray<Sku>>;
    selectedSkuId?: Maybe<string>;
    isMultiSku?: Maybe<boolean>;
}) => DisplayInfo;

// For multi--sku items, get displayInfo from the selected sku
export const getDisplayInfo: GetDisplayInfo = ({
    displayInfo,
    skus,
    selectedSkuId,
    isMultiSku,
}) => {
    if (isMultiSku && skus) {
        const selectedSku = skus.find(sku => sku?.serviceId === selectedSkuId);
        if (selectedSku?.displayInfo) {
            return selectedSku.displayInfo;
        }
    }

    return displayInfo;
};
